<div class="row mx-0 mb-1 mt-3">
  <div class="col-10">
    <ol class="breadcrumb">
      <li *ngFor="let item of breadCrumb; let idx = index; let last = last;">
        <a (click)="restoreState(idx)" *ngIf="!last">{{item}}</a>
        <a *ngIf="last">{{item}}</a>
      </li>
    </ol>
  </div>
</div>
<div class="row mx-0 mb-3" [ngClass]="isLoadingData ? 'd-none' : 'd-block'">
  <div class="col-11">
    <ag-grid-angular class="ag-theme-alpine mb-5 sg-documents-table document-grid" 
      [columnDefs]="columnDefs"
      [gridOptions]="gridOptions" 
      [rowData]="rowData" 
      (gridReady)="onGridReady($event)" 
      [pagination]="true"
      [paginationPageSize]="paginationPageSize"
      (rowClicked)="getFilterData($event)"
      [frameworkComponents]="onHoverTooltip" 
      (firstDataRendered)="restoreUserState()">
    </ag-grid-angular>
  </div>
</div>